<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-08-02 09:23:20
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-08 11:00:23
-->
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-01 16:28:52
-->
<template>
  <div>
    <el-drawer
      title="查看报备详情"
      :visible.sync="visibleTwo"
      @closed="close"
      :destroy-on-close="true"
      size="535px"
      :wrapperClosable="false"
      :with-header="true"
    >
      <a-spin :spinning="appLoading">
        <div class="applay-box">
          <el-tabs v-model="activeName" class="type-style" type="card" @tab-click="handleClick">
            <el-tab-pane :disabled="!resData.isApplyReportOneStageEntity"  label="第一阶段" name="first"></el-tab-pane>
            <el-tab-pane :disabled="!resData.isApplyReportTowStageEntity" label="第二阶段" name="second"></el-tab-pane>
            <el-tab-pane :disabled="!resData.isApplyReportThreeStageEntity"   label="第三阶段" name="third"></el-tab-pane>
          </el-tabs>
          <div class="box-one" v-if="type == 1">
            <div class="txt-box">
              <div class="txt">受理机关</div>
              <div class="txt-two">{{resData.isApplyReportOneStageEntity && resData.isApplyReportOneStageEntity.disposeOffice}}</div>
            </div>
            <div class="txt-box">
              <div class="txt">提交人</div>
              <div class="txt-two">{{resData && resData.stageName}}</div>
            </div>

            <div class="txt-box">
              <div class="txt">提交时间</div>
              <div class="txt-two">{{resData && resData.creationTime}}</div>
            </div>
            <div class="txt-box">
              <div style="width:100px" class="txt">申请人姓名</div>
              <div class="txt-two">{{resData.isApplyReportOneStageEntity && resData.isApplyReportOneStageEntity.name}}</div>
            </div>
            <div class="txt-box">
              <div class="txt">申请日期</div>
              <div class="txt-two">{{resData.isApplyReportOneStageEntity && resData.isApplyReportOneStageEntity.applyTime}}</div>
            </div>
            <div class="txt-box">
              <div class="txt">申请事项</div>
              <div class="txt-two">
                <div style="margin-bottom:12px" v-if="resData.isApplyReportOneStageEntity && resData.isApplyReportOneStageEntity.content">{{resData.isApplyReportOneStageEntity && resData.isApplyReportOneStageEntity.content}}</div>
                <el-image
                  class="txt-two-img"
                  v-for="item in accessory"
                  :src="item"
                  :preview-src-list="accessory"
                >
                </el-image>
                <div v-for="(item, index) in filePaths" :key="index">
                  <a style="display: flex;align-items: center;cursor: pointer;margin-bottom: 10px" :href="item.url" :download="item.name"><i class="ri-file-list-2-line" style="margin-right: 12px"></i>{{ item.name }}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="box-one" v-if="type == 2">
            <div class="txt-box">
              <div class="txt">提交人</div>
              <div class="txt-two">{{resData && resData.stageName}}</div>
            </div>
            <div class="txt-box">
              <div class="txt">提交时间</div>
              <div class="txt-two">{{resData && resData.creationTime}}</div>
            </div>
            <div class="txt-box">
              <div class="txt">答复日期</div>
              <div class="txt-two">{{resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.answerTime}}</div>
            </div>
            <div class="txt-box">
              <div class="txt">处理情况</div>
              <div class="txt-two">
                <div>{{resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.content}}</div>
                <el-image
                  class="txt-two-img"
                  v-for="item in accessoryTwo"
                  :src="item"
                  :preview-src-list="accessoryTwo"
                >
                </el-image>
                <div v-for="(item, index) in filePathsTwo" :key="index">
                  <a style="display: flex;align-items: center;cursor: pointer;margin-bottom: 10px" :href="item.url" :download="item.name"><i class="ri-file-list-2-line" style="margin-right: 12px"></i>{{ item.name }}</a>
                </div>
              </div>
            </div>
             <div class="txt-box">
              <div style="width:100px" class="txt">申请人情况</div>
              <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.applicatType == 0" class="txt-two">自然人（{{resData.isApplyReportTowStageEntity.applicatNumber}}）</div>
              <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.applicatType == 1" class="txt-two">商业企业</div>
              <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.applicatType == 2" class="txt-two">科研机构</div>
              <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.applicatType == 3" class="txt-two">社会公益组织</div>
              <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.applicatType == 4" class="txt-two">法律服务机构</div>
              <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.applicatType == 5" class="txt-two">其他</div>
            
            </div>
              <div class="txt-box">
              <div class="txt">公开方式</div>
             <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.openWay == 0" class="txt-two">予以公开</div>
             <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.openWay == 1" class="txt-two">部分公开</div>
             <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.openWay == 2" class="txt-two">不予公开</div>
             <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.openWay == 3" class="txt-two">无法提供</div>
             <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.openWay == 4" class="txt-two">不予处理</div>
             <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.openWay == 5" class="txt-two">其他处理</div>
             <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.openWay == 6" class="txt-two">结转下年度继续办理</div>
            </div>
              <div class="txt-box">
              <div class="txt">所属类型</div>
              <div class="txt-two">{{resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.belongToWord}}</div>
            </div>
             <div class="txt-box">
              <div style="width:200px" class="txt">是否了解申请人意图</div>
              <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.isApplyIntention==0" class="txt-two">是</div>
              <div v-if="resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.isApplyIntention==1" class="txt-two">否</div>
            </div>
             <div class="txt-box">
              <div style="width:100px" class="txt">申请人意图</div>
              <div class="txt-two">{{resData.isApplyReportTowStageEntity && resData.isApplyReportTowStageEntity.applyIntention}}</div>
            </div>
          </div>
          <div class="box-one" v-if="type == 3">
            <div class="txt-box">
              <div class="txt">提交人</div>
              <div class="txt-two">{{resData && resData.stageName}}</div>
            </div>
             <div class="txt-box">
              <div class="txt">提交时间</div>
              <div class="txt-two">{{resData && resData.creationTime}}</div>
            </div>
             <div class="txt-box">
              <div class="txt">行政复议</div>
              <div :style="{color: resData.isApplyReportThreeStageEntity && resData.isApplyReportThreeStageEntity.administrativeReview.indexOf('未产生') != -1?'':'#F56C6C'}" class="txt-two">{{resData.isApplyReportThreeStageEntity && resData.isApplyReportThreeStageEntity.administrativeReview}}</div>
            </div>
              <div class="txt-box">
              <div class="txt">行政诉讼</div>
              <div :style="{color: resData.isApplyReportThreeStageEntity && resData.isApplyReportThreeStageEntity.administrativeProceeding.indexOf('未产生') != -1?'':'#F56C6C'}" class="txt-two">{{resData.isApplyReportThreeStageEntity && resData.isApplyReportThreeStageEntity.administrativeProceeding}}</div>
            </div>
          </div>
        </div>
      </a-spin>
      <div class="bottom">
        <div class="form-bottom">
          <el-button @click="close" size="small">关闭</el-button>
          <el-button
            type="danger"
            plain
            size="small"
            v-if="codeData.indexOf('419') != -1"
            :loading="loadingShow"
            @click="bohui"
            style="margin-left: 14px"
            >驳回</el-button
          >
        </div>
      </div>
    </el-drawer>
    <el-dialog
      title="驳回报备?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      custom-class="tips-box"
      :before-close="quxiao"
      top="17%"
    >
      <span>驳回后，该报备信息内的所有信息将可以被修改，当提交人再次提交时，报备表将再次被锁定无法修改。</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="quxiao">取消</el-button>
        <el-button size="medium" :loading="submitShow" type="danger" @click="submitData">确认驳回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {isApplyReportDeils,updateType} from '../index'
export default {
  data() {
    return {
      visibleTwo: false,
      itemData: {},
      loadingShow: false,
      codeData: [],
      activeName:'first',
      type:1,
      dialogVisibleTwo:false,
      submitShow:false,
      resData:{},
      accessory:[],
      accessoryTwo:[],
      filePaths:[],
      filePathsTwo:[],
      appLoading:false,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: {},
    },
  },
  components: {},
  mounted() {},
  methods: {
    closeTwo() {
      this.$emit("closeTwo");
    },
    close() {
      this.$emit("close");
    },
    getDeils() {
      this.appLoading = true;
      this.type = 1;
      this.activeName = 'first'
      isApplyReportDeils({
        id:this.item.id,
      }).then((res)=>{
          if(res.code == 0){
              this.resData = res.data;
              let urls = this.resData && this.resData.isApplyReportOneStageEntity && this.resData.isApplyReportOneStageEntity.accessory && this.resData.isApplyReportOneStageEntity.accessory;
              urls = urls?JSON.parse(urls):[];
              let paths = [];
              let filePaths = [];
              for (let index = 0; index < urls.length; index++) {
                const element = urls[index];
                const fileSuffix = element.name.substring(element.name.lastIndexOf(".") + 1);
                // 将后缀名为png\jpg\jpeg格式的文件push进paths数组中
                if (fileSuffix == "png" || fileSuffix == "jpg" || fileSuffix == "jpeg") {
                  paths.push(this.imgIp + element.url);
                }else{
                  filePaths.push({name:element.name,url:this.imgIp + element.url});
                }
              }
              this.accessory = paths;
              this.filePaths = filePaths;
              let urlsTwo = this.resData && this.resData.isApplyReportTowStageEntity && this.resData.isApplyReportTowStageEntity.accessory && this.resData.isApplyReportTowStageEntity.accessory;
               urlsTwo = urlsTwo?JSON.parse(urlsTwo):[];
              let pathsTwo = [];
              let filePathsTwo = [];
              for (let index = 0; index < urlsTwo.length; index++) {
                const element = urlsTwo[index];
                const fileSuffix = element.name.substring(element.name.lastIndexOf(".") + 1);
                // 将后缀名为png\jpg\jpeg格式的文件push进paths数组中
                if (fileSuffix == "png" || fileSuffix == "jpg" || fileSuffix == "jpeg") {
                  pathsTwo.push(this.imgIp + element.url);
                }else{
                  filePathsTwo.push({name:element.name,url:this.imgIp + element.url});
                }
              }
              this.filePathsTwo = filePathsTwo;
              this.accessoryTwo = pathsTwo;
              this.appLoading = false;
          }
      })
      
    },
     handleClick(){
        if(this.activeName == 'first'){
            this.type = 1;
        }
         if(this.activeName == 'second'){
            this.type = 2;
        }
         if(this.activeName == 'third'){
            this.type = 3;
        }
      },
      bohui(){
          this.dialogVisibleTwo = true;
      },
      quxiao(){
        this.dialogVisibleTwo = false;
      },
      submitData(){
        this.submitShow = true;
        updateType({
          id:this.item.id,
        }).then((res)=>{
          if(res.code == 0){
            this.submitShow = false;
                this.dialogVisibleTwo = false;
                this.closeTwo();
          }
        })
       
      }
  },
  created() {},
  watch: {
    visible(val) {
      this.visibleTwo = val;
      if (this.visibleTwo) {
        this.getDeils();
        this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 10px;
  padding-top: 10px;
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 14px;
}
.el-drawer__close-btn {
  font-size: 14px;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.applay-box {
  padding: 24px;
  padding-bottom: 20px;
  padding-top: 0px;
  padding-bottom: 100px;
}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .icon-title {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background-color: rgba(23, 109, 230, 1);
  }
  .title-txt {
    color: rgba(23, 109, 230, 1);
    font-size: 16px;
    font-family: HarmonyOS_Sans_SC-regular;
    margin-left: 10px;
    font-weight: 600;
  }
}
.txt {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
  width: 80px;
}
.txt-two {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  width: 100%;
}
.txt-box {
  margin-bottom: 20px;
  display: flex;
}
.txt-two-img {
  width: 90px;
  height: 90px;
  margin-right: 14px;
  background: #f6f6f6;
  margin-top: 10px;
  /deep/ .el-image__inner {
    object-fit: contain;
  }
}
/deep/ .el-descriptions--medium.is-bordered .el-descriptions-item__cell {
  padding: 8px;
  &:first-child {
    width: 120px;
  }
}
.label-box {
  width: 300px;
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  margin-bottom: 16px;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
.switch-box {
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  font-family: Roboto-regular;
  margin-top: 8px;
}
.score-box {
  width: 417px;
  max-height: 256px;
  overflow-y: auto;
  border-radius: 4px;
  text-align: left;
  border: 1px solid rgba(220, 223, 230, 1);
  margin-top: -10px;
  padding: 8px;
  padding-top: 0px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  /deep/ .el-checkbox__label {
    display: block;
    width: 100%;
    padding-left: 4px;
  }
  /deep/ .el-checkbox__input {
    margin-top: 3px;
  }
  .item {
    width: 42%;
    margin-top: 6px;
    display: flex;
    align-items: center;
    .item-txt {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
    }
  }
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  border-top: solid 1px #e5e7ec;
  width: 100%;
  background: #fff;
  .form-bottom {
    margin-right: 24px;
    padding: 15px 0px;
  }
}
.el-button--primary {
  background: #176de6;
}
.box-one{
  margin-top: 10px;
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
/deep/ .is-disabled{
  color: rgba(102, 111, 128, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  background-color: rgba(224, 224, 224, 0.5);
}
</style>